import React from "react";
import styled from "styled-components";
import { Row } from "components/shared/layout";
import colours from "assets/colours";
import { string, func, bool } from "prop-types";

const Container = styled.div`
  background: ${colours.darkGreenTinted};
  border: 1.5px solid ${colours.darkGreen};
  box-sizing: border-box;
  border-radius: 85px;
  height: 3.125em;
  cursor: pointer;
  padding: 0em 1em;
  height:100%;
`;

const Icon = styled.img``;

const FileName = styled.div`
  font-weight: bold;
  font-size: 1rem;
  line-height: 110%;
  align-items: center;
  color: ${colours.darkGreen};
`;

const UploadedFile = ({
  fileName,
  fileURL,
  onRemove,
  showFileIcon = true,
  style = {},
}) => {
  const openFile = () => window.open(fileURL, "_blank");
  return (
    <Container style={style}>
      <Row style={{ height: "100%", display: "flex", flexWrap: "nowrap", }} alignItems="center">
        {showFileIcon && (
          <Icon
            style={{ marginRight: "0.75em" }}
            onClick={openFile}
            src={require("assets/images/document-icon.svg")}
            alt="View uploaded document"
          />
        )}
        <FileName onClick={openFile}>{fileName}</FileName>
        {onRemove && (
          <Icon
            style={{ marginLeft: "10px", marginTop: '2px' }}
            src={require("assets/images/cross-icon.svg")}
            alt="Remove uploaded document"
            onClick={onRemove}
          />
        )}
      </Row>
    </Container>
  );
};

export default UploadedFile;

UploadedFile.propTypes = {
  fileName: string.isRequired,
  fileURL: string.isRequired,
  onRemove: func,
  fileIcon: bool,
};
